import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleX } from '@fortawesome/pro-solid-svg-icons';
import { Input } from 'antd';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';

/**
 * @param {import('antd').InputProps} props
 */
export function SearchBox(props) {
  const lang = useSelector(getLang('GENERAL'));
  return (
    <Input.Search
      {...props}
      allowClear={{
        clearIcon: (
          <span role="img" aria-label={lang.CLEAR_SEARCH_FIELD}>
            <FontAwesomeIcon icon={faCircleX} size="md" />
          </span>
        ),
      }}
    />
  );
}
